<mat-card *ngIf="isShowError">
	<pre>
		{{showingError | json}}
	</pre>
</mat-card>
